import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("E:/Websites/RRnuxt1/layouts/default.vue").then(m => m.default || m))
}